import shopifyProductProfile from '../../components/shopify/productProfile/shopifyProductProfile2';

import carousel from '../../components/misc/carousel';
import saveGroupDropdown from '../../components/group/saveGroupDropdown';

var vue = new Vue({
    el: '#main-wrapper',
    components: {
        shopifyProductProfile,
        carousel,
        saveGroupDropdown
    },
    data: {
        product: null,
        loading: {
            quick_save: false
        },
        product_lists: [],
        related_collections: [],
        carousel_options: {
            direction: 'horizontal',
            slidesPerView: 'auto',
            spaceBetween: 10,
            loop: false,
            freeMode: false,
            navigation: {}
        },
        selected_image: null,
        groups: [],
        selected_group: null,
        has_show_more_text_button: false,
        show_more_text: false,
        watchlist: null,
        price_history_chart: null,
        expand_price_history: false
    },
    computed: {
        image_url: function () {
            if (this.selected_image) {
                return this.selected_image.src;
            }
            if(window.is_mobile && this.product.thumbnail){
                return this.product.thumbnail;
            }
            if (this.product && this.product.image) {
                return this.product.image.src;
            }
            return '/img/ui/image_placeholder.png';
        },
        is_saved: function(){
            if(!this.product){
                return false;
            }
            var groups = this.groups || [];
            for(var i=0; i < groups.length; i++){
                var group = groups[i];
                var item_ids = group.item_ids || [];
                if(item_ids.includes(this.product.id)){
                    return true;
                }
            }
            return false;
        },
        bookmark_count: function(){
            if(!this.product){
                return 0;
            }
            var count = 0;
            var groups = this.groups || [];
            for(var i=0; i < groups.length; i++){
                var group = groups[i];
                var item_ids = group.item_ids || [];
                if(item_ids.includes(this.product.id)){
                    count++;
                }
            }
            return count;
        },
        host: function(){
            var store = this.product.shop;
            if(store && store.domain){
                return store.domain;
            }
            if(!this.shopify_url){
                if(this.preview){
                    return 'example.com';
                }
                return;
            }
            try {
                var url_object = new URL(this.product_url);
                if(url_object && url_object.host){
                    return url_object.host.replace('www.', '');;
                }
            } catch (e){}
        }
    },
    created: function () {
        var self = this;
        this.product = JSON.parse(document.getElementsByName('product')[0].value);
        this.product_lists = window.product_lists;
        this.related_collections = window.related_collections;
        
        if(this.product && this.product.images && this.product.images.length){
            if(window.is_mobile){
                
            } else {
                this.selectImage(this.product.images[0]);
            }
        }
        this.groups = window.my_groups;
        
        this.setThumbnails();
    },
    mounted: function () {
        var self = this;
        
        this.setShowMoreText();
        
        window.bus.$on('watchlist-loaded', function(watchlist){
            self.watchlist = watchlist;
            self.setWatchlistFlag(self.product.id);
        });
            
        if(typeof watchlist === 'object'){
            this.watchlist = watchlist;
            this.setWatchlistFlag(this.product.id);
        }
        
        if(this.product.price_history && this.product.price_history.length >= 1){
            this.initChartJS();
        }
    },
    methods: {
        setThumbnails: function(){
            var regex = /(.*)\.(jpg|webp|png)/;
            for(var i=0; i < this.product.images.length; i++){
                var image = this.product.images[i];
                var src = image.src;
                var thumbnail = src.replace(regex, '$1_200x200.$2');
                Vue.set(image, 'thumbnail', thumbnail);
            }
        },
        getPreviousPrice: function(unit_price, percentage_increase){
            if(percentage_increase === -100){
                return;
            }
            var previous_price = unit_price / (1 + percentage_increase / 100);
//            previous_price = Math.round(previous_price / 100) * 100;
            return previous_price;
        },
        showMorePriceHistory: function(){
            this.expand_price_history = !this.expand_price_history;
        },
        initChartJS: function(){
            var self = this;
            var id = 'ChartJSScript1';
            var script = document.getElementById(id);
            if(!script){
                script = document.createElement('script');
                var src = 'https://cdn.jsdelivr.net/npm/chart.js';
                script.id = id;
                script.setAttribute('src', src);
                document.head.appendChild(script);
                script.onload = function(){                    
                    
                    id = 'ChartJSScript2';
                    script = document.getElementById(id);
                    if(!script){
                        script = document.createElement('script');
                        var src = 'https://cdn.jsdelivr.net/npm/chartjs-adapter-moment@^1';
                        script.id = id;
                        script.setAttribute('src', src);
                        document.head.appendChild(script);
                        script.onload = function(){
                            
                            id = 'ChartJSScript3';
                            script = document.getElementById(id);
                            if(!script){
                                script = document.createElement('script');
                                var src = 'https://cdn.jsdelivr.net/npm/chartjs-plugin-datalabels@2.0.0';
                                script.id = id;
                                script.setAttribute('src', src);
                                document.head.appendChild(script);
                                script.onload = function(){
                                    self.initCharts();
                                }
                            }
                        }
                    }

                    
                }
                
            }
        },
        initCharts: function(){
            var style = getComputedStyle(document.body);
            var text_color = style.getPropertyValue('--text-color');
            var border_color = style.getPropertyValue('--border-color');

            Chart.defaults.borderColor = border_color;
            Chart.defaults.color = text_color;

            Chart.register(ChartDataLabels);
            
            var options = this.getLineChartOptions();
            var data = this.getPriceHistoryData();
            var config = {
                type: 'line',
                data: data,
                options: options
            };

            if (this.price_history_chart) {
                this.price_history_chart.destroy();
            }
            var el = document.getElementById('priceHistoryChart');
            if(el){
                this.price_history_chart = new Chart(el, config);
            }
            
        },
        getPriceHistoryData: function(){
            var datasets = [];
            var labels = [];
            var dataset = {
                label: 'Price History',
                data: [],
                backgroundColor: "#28a745",
                borderColor: "#28a745",
                borderWidth: 2,
                pointRadius: 0
            };
            
            //Calculate the first price ever found for this product
            var first_item = this.product.price_history[0];
            if(first_item && first_item.date && first_item.price){
                var date = moment(first_item.date).subtract(7, 'day');
                var price = this.getPreviousPrice(first_item.price, first_item.price_change);
                labels.push(date);
                dataset.data.push(price);
            }
            
            for(var i=0; i < this.product.price_history.length; i++){
                var item = this.product.price_history[i];
                labels.push(item.date);
                dataset.data.push(item.price);
            }
            
            datasets.push(dataset);
            
            var data = {
                datasets: datasets,
                labels: labels
            };
            
            return data;
        },
        getLineChartOptions: function () {
            
            var options = {
                responsive: true,
                maintainAspectRatio: false,
                layout: {
                    padding: {
                        right: 16,
                    }
                },
                scales: {
                    x: {
                        grid: {
                            display: false,
                        },
                        type: 'time',
                        time: {
//                            unit: 'month',
                            minUnit: 'day',
                            displayFormats: {
                                month: 'MMM YYYY',
                            },
                            tooltipFormat: 'MMMM D YYYY'
                        },
                        ticks: {
                            display: true,
                            autoSkip: true,
                            padding: 0,
                            maxTicksLimit: 5,
                            maxRotation: 0,
                        },
                    },
                    y: {
                        beginAtZero: false,
                        offset: false,
                        grid: {
                            display: false,
                        },
                        ticks: {
//                            color: '#e5e5e5',
                            padding: 10,
                            precision: 0,
                            maxTicksLimit: 5,
                            callback: function(value, index, ticks) {
                                return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value / 100);
                            }
                        },
                    }
                },
                interaction: {
                    intersect: false,
                    mode: 'index',
                },
                plugins: {
                    tooltip: {
                        position: 'nearest',
                        callbacks: {
                            label: function(context) {
                                let label = '';

                                if (context.parsed.y !== null) {
                                    label = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(context.parsed.y / 100);
                                }
                                return label;
                            }
                        }
                    },
                    legend: {
                        display: false,
                    },
                    datalabels: {
                        display: false,
                        formatter: (value, ctx) => {
                            if(value){
                                return this.$options.filters.shortenNumber(value);
                            }
                            return '';
                        }
                    }
                }
            };
            
            return options;
        },
        selectImage: function (image) {
            this.selected_image = image;
        },
        openShareModal: function(){
            $('#socialShareModal').modal('show');
        },
        onGroupUpdated: function(data){
            return;
            var group = data.group;
            var groups = this.groups || [];
            for(var i=0; i < groups.length; i++){
                if(groups[i].uuid === group.uuid){
                    Object.assign(groups[i], group);
                    break;
                }
            }
        },
        onSelectedGroup: function(group){
            this.selected_group = group;
        },
        onLoadedGroups: function(groups){
            this.groups = groups;
        },
        quickSave: function(){
            if(!this.auth_user){
                window.bus.$emit('show_login_form');
                return;
            }
            if(this.loading.quick_save){
                return;
            }
            var self = this;
            self.loading.quick_save = true;
            var url = '/api/v5/group/quick-save';
            var params = {
                item: this.product,
                type: 'shopify_product',
            };
            if(this.selected_group){
                params.group_id = this.selected_group.uuid;
            }
            axios.post(url, params).then(function (response) {
                var group = response.data.data;
                self.updateGroup(group);
                self.loading.quick_save = false;
                $(self.$el).modal('hide');

                self.$refs.saveGroupDropdown.suggestGroup(group);

                self.showSavedSnackbar(group);

            }).catch(function (error) {
                Raven.captureMessage(JSON.stringify(error));
                self.loading.quick_save = false;
                self.showErrorMessage(error);
            });
        },
        showSavedSnackbar: function(group){
            var self = this;
            var item_ids = group.item_ids || [];
            var image_url = this.product.image_url;
            if(this.product.images.length && this.product.images[0].thumbnail){
                image_url = this.product.images[0].thumbnail;
            }
            var snackbar = {
                image_url: image_url,
                pos: 'bottom-center'
            };

            if(item_ids.includes(this.product.id)){
                snackbar.text = 'Saved to <br><strong>' + group.name + '</strong>';
                snackbar.action_text = 'Undo';
                snackbar.action_callback = function(){
                    self.removeGroupItem(group);
                }
            } else {
                snackbar.text = 'Removed from <br><strong>' + group.name + '</strong>';
            }
            if(typeof RDSnackbar === 'object'){
                RDSnackbar.show(snackbar);
            } else {
                Snackbar.show(snackbar);
            }
        },
        removeGroupItem: function(group){
            var self = this;

            var url = '/api/v5/group/' + group.uuid + '/remove-item';
            var params = {
                item: this.product
            };

            axios.post(url, params).then(function (response) {
                var group_data = response.data.data;
                if(group_data){
                    self.updateGroup(group_data);
                }

                RDSnackbar.show({
                    text: 'Item removed from list!'
                });

            }).catch(function (error) {
                Raven.captureMessage(JSON.stringify(error));
                self.showErrorMessage(error);
            });
        },
        updateGroup: function(group_data){
            var groups = this.groups || [];
            var index = groups.map(function(g){
                return g.uuid;
            }).indexOf(group_data.uuid);
            if(index > -1){
                //Group exists. Update it with new data
                Object.assign(groups[index], group_data);
            } else {
                //Group isn't in array. Add it groups
                groups.push(group_data);
            }
            this.groups = groups;
        },
        formatCurrency: function(unit_amount){
            var num = unit_amount / 100; //convert to dollars
            num = num.toLocaleString('en-US', {
                style: 'currency',
                currency:'USD',
                maximumFractionDigits: 2,
                minimumFractionDigits: 2
            });
            return num;
        },
        setShowMoreText: function(){
            var el = document.getElementById('ProductDescription');
            this.has_show_more_text_button = el && el.clientHeight > 94;
        },
        toggleShowMoreText: function(){
            this.show_more_text = !this.show_more_text;
        },
        onImageError: function(event){
            var img = event.target;
            img.onerror = null;
            img.src = '/img/product_placeholder.png';
            img.style.aspectRatio = 1;
            img.style.backgroundColor = '#777f8e';
        },
        toggleWatchlist: function(product_id){
            if(!this.auth_user){
                window.bus.$emit('show_login_form');
                return;
            }
            if(!this.watchlist){
                return;
            }
            
            if(!product_id){
                product_id = this.product.id;
            }
            
            var product_ids = this.watchlist.product_ids || [];
            var in_watchlist = product_ids.includes(product_id);
            
            if(in_watchlist){
                this.removeFromWatchlist(product_id);
            } else {
                this.addToWatchlist(product_id);
            }
        },
        addToWatchlist: function(product_id){
            var self = this;
            if(self.loading.watchlist) {
                return;
            }
            self.loading.watchlist = true;
            var url = '/api/v5/shop/watchlist/add';
            var params = {
                product_ids: [product_id],
                append: ['products']
            };
            axios.post(url, params).then(function (response) {
                self.watchlist = response.data.data;
                self.loading.watchlist = false;
                self.setWatchlistFlag(product_id);
                self.showWatchlistSnackbar(true, product_id);
                window.bus.$emit('watchlist-edited', self.watchlist);
            }).catch(function (error) {
                Raven.captureMessage(JSON.stringify(error));
                self.loading.watchlist = false;
            });
        },
        removeFromWatchlist: function(product_id){
            var self = this;
            if(self.loading.watchlist) {
                return;
            }
            self.loading.watchlist = true;
            var url = '/api/v5/shop/watchlist/remove';
            var params = {
                product_ids: [product_id],
                append: ['products']
            };
            axios.post(url, params).then(function (response) {
                self.watchlist = response.data.data;
                self.loading.watchlist = false;
                self.setWatchlistFlag(product_id);
                self.showWatchlistSnackbar(false, product_id);
                window.bus.$emit('watchlist-edited', self.watchlist);
            }).catch(function (error) {
                Raven.captureMessage(JSON.stringify(error));
                self.loading.watchlist = false;
            });
        },
        setWatchlistFlag: function(product_id){
            var product_ids = this.watchlist.product_ids || [];
            var in_watchlist = product_ids.includes(product_id);
            
            if(this.product.id === product_id){
                Vue.set(this.product, '_in_watchlist', in_watchlist);
            } else {
                if(in_watchlist){
                    $(`[data-watchlist-product="${product_id}"]`).addClass('btn-primary');
                    $(`[data-watchlist-product="${product_id}"]`).removeClass('btn-default');
                    $(`[data-watchlist-product="${product_id}"]`).attr('title', 'Remove from watchlist');
                } else {
                    $(`[data-watchlist-product="${product_id}"]`).removeClass('btn-primary');
                    $(`[data-watchlist-product="${product_id}"]`).addClass('btn-default');
                    $(`[data-watchlist-product="${product_id}"]`).attr('title', 'Add to watchlist');
                }
                
            }
        },
        showWatchlistSnackbar: function(added, product_id){
            var self = this;
            var snackbar = {
                pos: 'bottom-center'
            };
            
            if(this.product.id === product_id){
                snackbar.image_url = this.image_url;
            } else {
                snackbar.image_url = $(`[data-product-card-id="${product_id}"] img.product-image`).attr('src');
            }

            if(added){
                snackbar.text = 'Item added to your <strong>watchlist</strong>';
                snackbar.action_text = 'Undo';
                snackbar.action_callback = function(){
                    self.removeFromWatchlist(product_id);
                };
            } else {
                snackbar.text = '<strong>Item removed from watchlist!</strong>';
            }
            if(typeof RDSnackbar === 'object'){
                RDSnackbar.show(snackbar);
            } else {
                Snackbar.show(snackbar);
            }
        },
        redirectToProductPage: function(){
            var url = this.product.referral_url;
            window.open(url);
        }
    }
});



// WEBPACK FOOTER //
// ./resources/views/rd/assets/js/v2/views/shopify/productProfile.js